<template>
    <div id="lv1">
        <div id="main">
            <FullPageCarousel :images="images" id="carousel"></FullPageCarousel>

            <div id="widgetContainer">
                <div class="d-flex h-100">
                    <div class="row align-items-center justify-content-center no-gutters">
                        <div class="col-xl-6 col-lg-8 col-sm-12" style="max-height: 100%;overflow-y: scroll">
                            <SearchWidget></SearchWidget>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div  id="regionsContainer">
            <RegionCarousel></RegionCarousel>
        </div>

        
        <div class="container" style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row row-eq-height">
                <template v-for="box in boxes" >
                    <div class="col-md-6 col-xs-12 boxCol" :key="box.title"> 
                        <IconBox 
                            :title="box.title" 
                            :icon="box.icon"
                            :buttonTitle="box.buttonTitle" 
                            :buttonHref="box.buttonHref"
                        >
                            <h4 v-if="box.content.title">{{ box.content.title }}</h4>
                            <p v-if="box.content.description">{{ box.content.description }}</p>
                        </IconBox>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import { viewMixin } from '../mixins/viewMixin';
import IconBox from "@/components/level1/IconBox";
import FullPageCarousel from "@/components/level1/FullPageCarousel";
import RegionCarousel from "@/components/level1/RegionCarousel";
import SearchWidget from "@/components/level2/searchWidget/SearchWidget";

export default {
    name: 'LevelOneView',
    mixins: [viewMixin],
    components: {
        SearchWidget,
        IconBox,
        FullPageCarousel,
        RegionCarousel
    },
    metaInfo() {
        return {
            title: `casafile - Ferienwohnung Tessin, Ferienhaus, Rustico, Lago Maggiore, Locarno, Lugano, Ascona, Gambarogno, Ferien im Ticino mit Hund un Kinder`
        }
    },
    computed: {
        boxes: function() {
            return [
                this.$i18n.t('views.lv1.boxes.presentation'),
                this.$i18n.t('views.lv1.boxes.clients'),
                this.$i18n.t('views.lv1.boxes.estimates'),
                this.$i18n.t('views.lv1.boxes.sale')
            ]
        }
    },
    data() {
        return {
            images: [
                {
                    url: require('@/assets/images/ticino01.jpg'),
                },
                {
                    url: require('@/assets/images/ticino02.jpg'),
                },
                {
                    url: require('@/assets/images/ticino03.jpg'),
                },
                {
                    url: require('@/assets/images/ticino04.jpg'),
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    #lv1 {
        height: 100%;
    }

    #carousel {
        position: relative;
        top: 0;
        left: 0;
        object-fit: cover;
        height: 100%;
        width: auto;
    }

    #main {
        height: calc(100vh - #{$navbar-height});;
    }

    #widgetContainer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: $navbar-height;
    }

    // .infoContainer {
    //     position: absolute;
    //     top: -50px;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    // }

    #regionsContainer {
        background-color:$primary-color;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .row-eq-height {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap;
    }

    .boxCol {
        margin-top: 20px;
        margin-bottom: 20px;
    }


    .correct {
        width:100%;
    }

</style>

<style lang="scss">
</style>